import styled, { css } from 'styled-components';
import { shake } from 'components/mixins/interactivity';
import { transparentize } from 'utils/color';
import { Button } from 'components/common';
import media from 'components/mixins/media';
import buttonDefaultStyle from 'components/mixins/normalize';
import {
  ButtonElement,
  CheckIcon,
  ButtonWrapper
} from 'components/common/SwitchButton/SwitchButton.styled';

type InputContainerProps = {
  size: number;
}
export const InputContainer = styled.div<InputContainerProps>`
  margin-bottom: ${props => props.size}px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ButtonSubmitSingUp = styled(Button)`
  ${buttonDefaultStyle};
  background-color: ${props => props.theme.colors.mainColor};
  color: ${props => props.theme.colors.buttonTextColor};
  margin-top: 24px;
  min-width: 198px;
  max-width: 320px;
  text-overflow: ellipsis;
  display: flex;
  justify-content: center;
  align-items: center;
  ${media.mobile`
    min-width: 160px;
    max-width: 260px;
  `};
  & span {
    font-size: 14px;
  }
  & .icon {
    font-size: 8px;
  }
  &:hover {
    background-color: ${props => transparentize(props.theme.colors.mainColor, 0.9)};
  }
  &:focus {
    background-color: ${props => transparentize(props.theme.colors.mainColor, 0.9)};
    outline: 1px solid black;
  }
  &:focus:not(:focus-visible) {
    background-color: ${props => transparentize(props.theme.colors.mainColor, 0.9)};
    outline: none;
  }
  &:active {
    background-color: ${props => transparentize(props.theme.colors.mainColor)};
  }
  & > span:first-child {
    position: relative;
    width: auto;
    padding: 0 10px;
  }
  & > span:first-child:after {
    content: '*';
    position: absolute;
    top: -3px;
    left: 91%;
  }
`;

export const AgreementCheckBox = styled.input.attrs({
  type: 'checkbox',
  required: true
})`
  display: none;
  visibility: hidden;
`;

export const AgreementLabel = styled.label``;

type CheckboxContainerProps = {
  children?: any;
  validationStatusBeforeSubmit: boolean;
  isChecked: boolean;
};

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  user-select: none;
  margin-top: 18px;
  line-height: 2px;
  display: flex;
  align-item: center;
  width: 420px;
  ${media.mobile`
      width: 360px;
  `};
  ${props =>
    props.validationStatusBeforeSubmit === false &&
    css`
      & {
        ${shake('horizontal', 0.2, '5')}
      }
    `};
  ${ButtonWrapper} {
    width: 30px;
    outline: none;
    ${ButtonElement} {
      margin-top: -1px;
      margin-left: 40px;
      background-color: transparent;
      border: 1px solid;
      border-color: ${props =>
        props.validationStatusBeforeSubmit === false && !props.isChecked
          ? props.theme.colors.incorrectColor
          : transparentize(props.theme.colors.textColor, 0.5)};
    }
    &[role='checkbox'] {
      height: 30px;
      cursor: pointer;
      ${CheckIcon} {
        color: black;
      }
      &:focus {
        & ${ButtonElement} {
          border-color: ${props => props.theme.colors.mainColor};
        }
      }
      ${props =>
        !props.isChecked &&
        css`
          &:hover {
            & ${CheckIcon} {
              opacity: 0.2;
            }
          }
        `}
      }
    }
  }

  ${AgreementLabel} {
    width: 290px;
    margin-left: 5px;
    margin-top: 10px;
    ${media.mobile`
      width: 220px;
    `};
  }
`;
